/**
 * @generated SignedSource<<2453f2f447e1334e18243d95ba4a6511>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueResults_issueResults$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_DetailView_issueResults" | "main_issueNavigator_ListView_issueResults">;
  readonly " $fragmentType": "main_issueNavigator_IssueResults_issueResults";
};
export type main_issueNavigator_IssueResults_issueResults$key = {
  readonly " $data"?: main_issueNavigator_IssueResults_issueResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueResults_issueResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueResults_issueResults",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        },
        {
          "kind": "Variable",
          "name": "shouldQueryHasChildren",
          "variableName": "shouldQueryHasChildren"
        }
      ],
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_ListView_issueResults"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_DetailView_issueResults"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "fe345a65c78509e001254c068f756164";

export default node;
